import { each, filter, find, intersection, isNil, isNull, sumBy } from 'lodash';
import { DEFAULT_FORMAT } from '../constant';
import { ActivityTypeEnum, BusinessEnum, CalTimeTypeEnum, DiscountTypeEnum, EatTypeEnum } from '../enum';
import dayjs from '../lib/dayjs';
/**
 * 根据类型获取可用的活动
 * @param self this
 * @param types
 * @param opt
 */
export default function getEnableActivityByType(self, types, opt) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const typeActivitys = [];
    if (self.channel === '3rdDelivery') {
        return typeActivitys;
    }
    let nowTime = dayjs().format(DEFAULT_FORMAT);
    let nowDay = dayjs().day();
    let nowDate = dayjs(nowTime).date();
    let onlyBalancePay = true;
    if (!isNil(opt === null || opt === void 0 ? void 0 : opt.onlyBalancePay)) {
        onlyBalancePay = opt === null || opt === void 0 ? void 0 : opt.onlyBalancePay;
    }
    for (const activity of self.activities) {
        if (!(types === null || types === void 0 ? void 0 : types.includes(activity.type))) {
            continue;
        }
        // console.log(`获取这些类型的活动${types.join(',')}`);
        // console.log('当前会员卡');
        // console.log(self.optMemberCard);
        // console.log(`当前订单金额${orderPrice}`);
        // console.log(`当前opt.onlyBalancePay: ${opt?.onlyBalancePay}`);
        // console.log(`onlyBalancePay为 ${onlyBalancePay}`);
        if ([CalTimeTypeEnum.OrderTime, CalTimeTypeEnum.OrderTimeIncludeStartTime].includes((_a = self.config) === null || _a === void 0 ? void 0 : _a.discountCalTime)) {
            if (activity.type === ActivityTypeEnum.SingleItemDiscount) {
                if ((opt === null || opt === void 0 ? void 0 : opt.addTimes) && (opt === null || opt === void 0 ? void 0 : opt.addTimes.length) > 0) {
                    nowTime =
                        find(opt.addTimes, (addTime) => addTime >= activity.startTime && addTime <= activity.endTime) || nowTime;
                }
            }
            else {
                nowTime = (opt === null || opt === void 0 ? void 0 : opt.addTime) || nowTime;
            }
        }
        nowDay = dayjs(nowTime).day();
        nowDate = dayjs(nowTime).date();
        // console.log(`nowDay ${nowDay}`);
        // console.log(`nowDate ${nowDate}`);
        if ((activity.isAllMember ||
            (!((_b = self === null || self === void 0 ? void 0 : self.optMemberCard) === null || _b === void 0 ? void 0 : _b.isExpired) && intersection(activity.memberCards, self.availableCards).length > 0)) &&
            (((_c = activity.channelEatType) === null || _c === void 0 ? void 0 : _c.isAll) ||
                ((_d = activity.channelEatType) === null || _d === void 0 ? void 0 : _d.channels.find((channel) => (channel === null || channel === void 0 ? void 0 : channel.key) === self.channel && channel.eatTypes.includes(self.eatType) && channel.enable))) &&
            (types === null || types === void 0 ? void 0 : types.includes(activity.type)) && // 类型一样
            nowTime >= activity.startTime &&
            nowTime <= activity.endTime && // 在有效期的时间内
            (activity.isAllTime ||
                ((activity.timeRangeType === 'week' || isNull(activity.timeRangeType)) && ((_e = activity.days) === null || _e === void 0 ? void 0 : _e.includes(nowDay))) ||
                (activity.timeRangeType === 'month' && ((_f = activity.days) === null || _f === void 0 ? void 0 : _f.includes(nowDate)))) && // 一直有效或者在规定的星期几
            (!activity.promoCode || ((_g = opt === null || opt === void 0 ? void 0 : opt.promoCodes) === null || _g === void 0 ? void 0 : _g.includes(activity.promoCode))) && // 营销码
            (((opt === null || opt === void 0 ? void 0 : opt.business) && activity.business == (opt === null || opt === void 0 ? void 0 : opt.business)) ||
                ((!activity.business || activity.business === BusinessEnum.Meal) && self.eatType !== EatTypeEnum.Mall) ||
                (activity.business === BusinessEnum.Mall && self.eatType === EatTypeEnum.Mall))) {
            if (activity.isAllMember === false &&
                ((_h = activity.extra) === null || _h === void 0 ? void 0 : _h.balanceDiscountRule) === 'onlyBalancePay' &&
                onlyBalancePay !== true) {
                // console.log(
                //   `活动 ${activity.activityName} 被过滤掉了 ${activity.isAllMember} ${activity.extra?.balanceDiscountRule} ${onlyBalancePay}`,
                // );
                continue;
            }
            let isPushed = false;
            if (activity.type === ActivityTypeEnum.DesignatedItemDiscount) {
                if (activity.discountType === DiscountTypeEnum.DiscountFee) {
                    activity.transformDiscountValue = 1 - activity.discountValue / activity.orderFee;
                }
                else {
                    activity.transformDiscountValue = activity.discountValue;
                }
            }
            else if (activity.type === ActivityTypeEnum.LadderDiscount) {
                activity.averageDiscountValue =
                    sumBy(filter((_j = activity.extra) === null || _j === void 0 ? void 0 : _j.ladderDiscount, { enable: true }), 'discountValue') /
                        ((_l = (_k = activity.extra) === null || _k === void 0 ? void 0 : _k.ladderDiscount.length) !== null && _l !== void 0 ? _l : 1);
            }
            else if (activity.type === ActivityTypeEnum.FullItemNFree) {
                activity.extra &&
                    (activity.extra.freeFullProportion = (((_m = activity.extra) === null || _m === void 0 ? void 0 : _m.freeCnt) || 0) / (((_o = activity.extra) === null || _o === void 0 ? void 0 : _o.fullCnt) || 1));
            }
            if (!activity.isAllTime) {
                if (activity.timeRangeType === 'month') {
                    if ((_p = activity.days) === null || _p === void 0 ? void 0 : _p.includes(nowDate)) {
                        isPushed = true;
                        typeActivitys.push(activity);
                    }
                }
                else {
                    const nowHourTime = dayjs(nowTime).format('HH:mm');
                    each(activity.timeRanges, (timeRange) => {
                        if (timeRange.isOpen && timeRange.weekDay === nowDay) {
                            each(timeRange.ranges, (range) => {
                                if (range.startTime <= nowHourTime && range.endTime >= nowHourTime) {
                                    !isPushed && typeActivitys.push(activity);
                                    isPushed = true;
                                    (self === null || self === void 0 ? void 0 : self.addTimeout) && self.addTimeout(dayjs().format('YYYY-MM-DD') + ' ' + range.endTime + ':00');
                                }
                                else if (range.startTime > nowHourTime) {
                                    // 定时器任务
                                    (self === null || self === void 0 ? void 0 : self.addTimeout) && self.addTimeout(dayjs().format('YYYY-MM-DD') + ' ' + range.startTime + ':00');
                                }
                            });
                        }
                    });
                }
            }
            else {
                isPushed = true;
                typeActivitys.push(activity);
            }
        }
    }
    return typeActivitys;
}
//# sourceMappingURL=getEnableActivityByType.js.map